const getImageSrc = (imageName: string) => {
  return `${window.__config__.CONTROL_CENTER_URL}${imageName}`;
};

export default getImageSrc;
